import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["docsPath"];
import { EstimateGasExecutionError } from '../../errors/estimateGas.js';
import { UnknownNodeError } from '../../errors/node.js';
import { getNodeError } from './getNodeError.js';
export function getEstimateGasError(err, _ref) {
  let {
      docsPath
    } = _ref,
    args = _objectWithoutProperties(_ref, _excluded);
  const cause = (() => {
    const cause = getNodeError(err, args);
    if (cause instanceof UnknownNodeError) return err;
    return cause;
  })();
  return new EstimateGasExecutionError(cause, _objectSpread({
    docsPath
  }, args));
}
//# sourceMappingURL=getEstimateGasError.js.map